import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrorKeys } from '@shared/form-elements/model/form-elements.model';
import { TranslationKey } from '@shared/translations/auto-generated/translation-key';

@Pipe({
    name: 'validationErrorMessage',
    standalone: true
})
export class ValidationErrorMessagePipe implements PipeTransform {
    transform(errorKey: string | null): TranslationKey | '' {
        switch (errorKey as ValidationErrorKeys) {
            case 'required':
                return '';
            case 'phoneNumber':
                return 'forms.validationErrors.phoneNumber';
            case 'email':
                return 'forms.validationErrors.email';
            case 'zipCode':
                return 'forms.validationErrors.zipCode';
            case 'store':
                return 'forms.validationErrors.store';
            case 'matchEmail':
                return 'forms.validationErrors.matchEmail';
            case 'invalidCoupon':
                return 'forms.validationErrors.invalidCoupon';
            case 'invalidCustomCoupon':
                return 'forms.validationErrors.invalidCustomCoupon';
            case 'throttled':
                return 'forms.validationErrors.throttled';
            case 'invalidGiftCard':
                return 'forms.validationErrors.invalidGiftCard';
            case 'isBlockedForWeb':
                return 'forms.validationErrors.isBlockedForWeb';
            case 'date':
                return 'forms.validationErrors.date';
            case 'burd':
                return 'forms.validationErrors.burd';
            case 'invalidEmailVerification':
                return 'forms.validationErrors.invalidEmailVerification';
            case 'invalidMembershipEmail':
                return 'forms.validationErrors.invalidMembershipEmail';
            case 'invalidStore':
                return 'forms.validationErrors.invalidStore';
            case 'cvr':
                return 'forms.validationErrors.cvr';
            default:
                return 'forms.validationErrors.generic';
        }
    }
}
